/* eslint-disable max-len, react/no-danger */
import { Text } from '@chakra-ui/react';
import TextSection from '@components/articles/SeoTextSection';
import { partBDeductible } from '@components/crm/utils/irmaa';
import { fontSize } from '@constants/styles';
import CoverageOutline from './common/CoverageOutline';
import Plans from './common/Plans';
import { planFOptions } from './constants';
import { randomizeContent } from './utils';

const coverage = [
  { covered: true, name: 'Part A Coinsurance' },
  { covered: true, name: 'Part A Hospice Care Coinsurance + Copay' },
  { covered: true, name: 'Part A Deductible' },
  { covered: true, name: 'Blood (3 Pints)' },
  { covered: true, name: 'Part B Coinsurance + Copay' },
  { covered: true, name: 'Part B Excess Charge' },
  { covered: true, name: 'Part B Deductible' },
];

const PlanF = ({ name, carriers, averagePremium, stateCode, renderCta }) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const generated: any = randomizeContent(planFOptions, name);

  return (
    <>
      <TextSection title={`What about Plan F in ${name}, ${stateCode}?`}>
        <Text fontSize={fontSize.p}>{generated.intro}</Text>

        {averagePremium && (
          <Text fontSize={fontSize.p}>{generated.averagePremium(name, averagePremium.toFixed(2))}</Text>
        )}

        <Text fontSize={fontSize.p}>{generated.sectionHeader}</Text>
        <CoverageOutline coverage={coverage} />

        {carriers.length ? (
          <Text
            fontSize={fontSize.p}
            dangerouslySetInnerHTML={{ __html: `${generated.bodyPartOne} ${generated.bodyPartTwo(name)}` }}
          />
        ) : (
          <>
            <Text fontSize={fontSize.p}>
              Call us if you are interested in exploring your Plan F options. Remember: if your Plan F premium is $19
              more than your Plan G premium, Plan G becomes the cheaper option because the Part B Deductible is only $
              {partBDeductible}. Plan F covering your Part B deductible is the only difference between it and Plan G.
            </Text>
            {renderCta()}
          </>
        )}
      </TextSection>
      {carriers.length && (
        <TextSection title={`Top 5 Cheapest Plan F Options in ${name}:`}>
          <Plans plans={carriers} />
          <Text fontSize={fontSize.p}>
            Premiums do vary by zip code, so contact us below to hear the local premiums you can actually enroll in.
          </Text>
          {renderCta()}
        </TextSection>
      )}
    </>
  );
};

export default PlanF;
